module.exports = __webpack_public_path__ + "img/avatar-8.1c618ff8.jpg";